module.exports = __webpack_public_path__ + "static/media/h5logo.63e02138.png";